import React from 'react';
import ReactDOM from 'react-dom'; // 1. Importar o ReactDOM
import styles from './ConfirmationModal.module.css';
import { useTranslation } from 'react-i18next';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText,
  cancelButtonText,
}) => {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }
  // 2. Encapsular o JSX com ReactDOM.createPortal
  return ReactDOM.createPortal(
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h3>{title}</h3>
        <p>{message}</p>
        <div className={styles.buttonGroup}>
          <button onClick={onClose} className={`${styles.button} ${styles.cancelButton}`}>
            {cancelButtonText || t('cancel')}
          </button>
          <button onClick={onConfirm} className={`${styles.button} ${styles.confirmButton}`}>
            {confirmButtonText || t('confirm')}
          </button>
        </div>
      </div>
    </div>,
    document.getElementById('confirmation-modal-portal') // 3. Apontar para o nosso novo div
  );
};

export default ConfirmationModal;